import Vue from "vue";
// import App from "./App.vue";
import axios from "axios";
import Buefy from "buefy";
import router from "./router";

Vue.config.productionTip = false;


// new Vue({
//   axios,
//   Buefy,
//   router,
//   render: h => h(App)
// }).$mount("#app");

new Vue({
  el: '#app',
  router,
  axios, 
  Buefy
}).$mount("#app");